export default __webpack_public_path__ + "static/media/O_Oculos.bbc4ea54.mp3";